import { keyBy } from "lodash";
import { IImport } from "../../types/imports/import";
import * as types from "../actions/actionTypes";
import { IImportsState, InitialState } from "./state";

const handles = {
  [types.IMPORT_UPLOAD_FULFILLED]: (state: IImportsState, imp: IImport) => {
    const st = {
      ...state,
      map: {
        ...state.map,
        [imp._id || "uploading"]: imp,
      },
      self: Array.from(new Set([imp._id, ...state.self])),
    };
    return st;
  },
  [types.IMPORT_TRIGGER_FULFILLED]: (state: IImportsState, imp: IImport) => ({
    ...state,
    map: { ...state.map, [imp._id || "uploading"]: imp },
  }),
  [types.IMPORT_GET_MY_FULFILLED]: (
    state: IImportsState,
    imports: IImport[],
  ) => ({
    ...state,
    self: imports.map((i) => i._id),
    map: { ...state.map, ...keyBy(imports, "_id") },
  }),
  [types.IMPORT_GET_FULFILLED]: (state: IImportsState, imp: IImport) => ({
    ...state,
    map: { ...state.map, [imp._id || ""]: imp },
  }),
};

export default function importReducer(state = InitialState.imports, action) {
  return action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
